/* unplugin-vue-components disabled */import __unplugin_components_1 from 'D:/workspace/space-time-web/src/components/Pagination/index.vue';
import __unplugin_components_0 from 'D:/workspace/space-time-web/src/components/RightToolbar/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "height": "56rem"
  }
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { listInstructions, delInstructions } from '@/api/base/instructions';
import { getToken } from '@/utils/auth';
export default {
  __name: 'instructions',
  setup(__props, {
    expose: __expose
  }) {
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const visible = ref(false);
    const loading = ref(true);
    const ids = ref([]);
    const single = ref(true);
    const multiple = ref(true);
    const showSearch = ref(true);
    const total = ref(0);
    const instructionList = ref([]);
    const dateRange = ref([]);
    const defaultSort = ref({
      prop: 'id',
      order: 'descending'
    });
    const queryParams = ref({
      pageNum: 1,
      pageSize: 10,
      beginTime: undefined,
      endTime: undefined,
      name: undefined,
      objId: undefined
    });
    const upload = reactive({
      // 是否显示弹出层（摄像头导入）
      open: false,
      // 弹出层标题（摄像头导入）
      title: '',
      fileList: [],
      // 是否禁用上传
      isUploading: false,
      // 设置上传的请求头部
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      // 上传的地址
      url: process.env.VUE_APP_BASE_API + '/device/instructions/upload'
    });

    // 显示弹框
    function show(deviceId) {
      queryParams.value.objId = deviceId;
      getList();
      visible.value = true;
    }
    function getList() {
      if (dateRange.value.length > 0) {
        queryParams.value.beginTime = dateRange.value[0];
        queryParams.value.endTime = dateRange.value[1];
      }
      loading.value = true;
      listInstructions(queryParams.value).then(response => {
        instructionList.value = response.rows;
        total.value = response.total;
        loading.value = false;
      });
    }
    function instructionsDownload(row) {
      window.open(row.path, row.name);
    }
    function byteToSize(row, column) {
      if (row.fileSize === null) {
        return;
      }
      return proxy.byteToH(row.fileSize);
    }
    /** 搜索按钮操作 */
    function handleQuery() {
      queryParams.value.pageNum = 1;
      getList();
    }
    /** 重置按钮操作 */
    function resetQuery() {
      dateRange.value = [];
      queryParams.value.beginTime = undefined;
      queryParams.value.endTime = undefined;
      proxy.resetForm('queryRef');
      handleQuery();
    }
    // 多选框选中数据
    function handleSelectionChange(selection) {
      ids.value = selection.map(item => item.id);
      single.value = selection.length !== 1;
      multiple.value = !selection.length;
    }
    /** 排序触发事件 */
    function handleSortChange(column, prop, order) {
      queryParams.value.orderByColumn = column.prop;
      queryParams.value.isAsc = column.order;
      getList();
    }
    /** 删除按钮操作 */
    function handleDelete(row) {
      const currentids = row.id || ids.value;
      proxy.$modal.confirm('是否确认删除文件编号为"' + currentids + '"的数据项?').then(function () {
        return delInstructions(currentids);
      }).then(() => {
        getList();
        proxy.$modal.msgSuccess('删除成功');
      }).catch(() => {});
    }
    function handleUpload() {
      upload.open = true;
      upload.title = '文件上传';
      upload.fileList = [];
    }
    // 文件上传前执行
    function beforeUploadVideo(file) {
      const isLt30G = file.size / 1024 / 1024 < 1024;
      console.log(file.type);
      //大小限制不了，先限制在1g内，类型.pdf、.docx、.doc、.pptx、.ppt、.xlsx、.xls、.7z、.zip、rar
      if (["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/msword", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel", "application/x-7z-compressed", "application/x-zip-compressed", "application/x-rar-compressed"].indexOf(file.type) === -1) {
        proxy.$modal.msgError('请上传正确的文件格式');
        return false;
      }
      if (!isLt30G) {
        proxy.$modal.msgError('上传文件大小不能超过1G哦!');
        return false;
      }
    }
    // 关闭窗口
    function closeDialog() {
      upload.open = false;
      upload.isUploading = false;
    }
    //文件上传中处理
    const handleFileUploadProgress = (event, file, fileList) => {
      upload.isUploading = true;
    };
    // 文件上传成功是执行
    const handleFileSuccess = (res, file, fileList) => {
      if (res.code === 200) {
        proxy.$modal.msgSuccess('文件上传成功！');
        closeDialog();
        getList();
      } else {
        proxy.$modal.msgError('文件上传失败，请重新上传！');
      }
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_col = _resolveComponent("el-col");
      const _component_right_toolbar = __unplugin_components_0;
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_1;
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_upload_filled = _resolveComponent("upload-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        title: "说明书管理",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "120rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_withDirectives(_createVNode(_component_el_form, {
          model: _unref(queryParams),
          ref: "queryRef",
          inline: true,
          "label-width": "8.6rem"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "文件名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(queryParams).name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(queryParams).name = $event),
              placeholder: "请输入文件名称",
              clearable: "",
              style: {
                "width": "24rem"
              },
              onKeyup: _withKeys(handleQuery, ["enter"])
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "上传时间",
            style: {
              "width": "40rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _unref(dateRange),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(dateRange) ? dateRange.value = $event : null),
              type: "datetimerange",
              "range-separator": "-",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              class: "satpro-button",
              icon: "Search",
              onClick: handleQuery
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("搜索", -1)]))]),
              _: 1
            }), _createVNode(_component_el_button, {
              class: "satpro-button",
              icon: "Refresh",
              onClick: resetQuery
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("重置", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), [[_vShow, _unref(showSearch)]]), _createVNode(_component_el_row, {
          gutter: 10,
          class: "mb8"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 1.5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              class: "satpro-button",
              plain: "",
              icon: "Upload",
              onClick: handleUpload
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("文件上传", -1)]))]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 1.5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              class: "satpro-button",
              plain: "",
              icon: "Delete",
              disabled: _unref(multiple),
              onClick: handleDelete
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("删除", -1)]))]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          }), _createVNode(_component_right_toolbar, {
            showSearch: _unref(showSearch),
            onQueryTable: getList
          }, null, 8, ["showSearch"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_table, {
          data: _unref(instructionList),
          "default-sort": _unref(defaultSort),
          onSelectionChange: handleSelectionChange,
          onSortChange: handleSortChange,
          "header-cell-style": {
            background: 'transparent !important',
            color: '#FFFFFF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            label: "编号",
            align: "center",
            prop: "id"
          }), _createVNode(_component_el_table_column, {
            label: "文件名称",
            align: "center",
            prop: "name",
            "show-overflow-tooltip": true,
            sortable: "custom",
            "sort-orders": ['descending', 'ascending']
          }), _createVNode(_component_el_table_column, {
            label: "文件大小",
            align: "center",
            prop: "fileSize",
            formatter: byteToSize
          }), _createVNode(_component_el_table_column, {
            label: "上传时间",
            align: "center",
            prop: "uploadTime",
            sortable: "custom",
            "sort-orders": ['descending', 'ascending'],
            width: "180"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.uploadTime)), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "class-name": "small-padding fixed-width"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              icon: "View",
              onClick: $event => instructionsDownload(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("预览", -1)]))]),
              _: 1
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              icon: "Delete",
              onClick: $event => handleDelete(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("删除", -1)]))]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "default-sort"]), _withDirectives(_createVNode(_component_pagination, {
          total: _unref(total),
          page: _unref(queryParams).pageNum,
          "onUpdate:page": _cache[2] || (_cache[2] = $event => _unref(queryParams).pageNum = $event),
          limit: _unref(queryParams).pageSize,
          "onUpdate:limit": _cache[3] || (_cache[3] = $event => _unref(queryParams).pageSize = $event),
          onPagination: getList
        }, null, 8, ["total", "page", "limit"]), [[_vShow, _unref(total) > 0]])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(upload).open,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(upload).open = $event),
        title: _unref(upload).title,
        width: "40rem",
        "append-to-body": "",
        onBeforeClose: _cache[7] || (_cache[7] = $event => closeDialog()),
        "close-on-click-modal": false,
        draggable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref: "uploadRef",
          action: _unref(upload).url + '?objId=' + _unref(queryParams).objId,
          disabled: _unref(upload).isUploading,
          headers: _unref(upload).headers,
          "file-list": _unref(upload).fileList,
          limit: 1,
          "on-progress": handleFileUploadProgress,
          "before-upload": beforeUploadVideo,
          "on-success": handleFileSuccess,
          accept: ".pdf, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .7z, .zip, .rar",
          drag: ""
        }, {
          tip: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createElementVNode("div", {
            class: "el-upload__tip text-center"
          }, [_createElementVNode("span", null, "仅允许上传pdf、docx、doc、pptx、ppt、xlsx、xls、7z、zip、rar格式，文件大小限制在1G以内。")], -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--upload"
          }, {
            default: _withCtx(() => [_createVNode(_component_upload_filled)]),
            _: 1
          }), _cache[16] || (_cache[16] = _createElementVNode("div", {
            class: "el-upload__text"
          }, [_createTextVNode("将文件拖到此处，或"), _createElementVNode("em", null, "点击上传")], -1))]),
          _: 1
        }, 8, ["action", "disabled", "headers", "file-list"])]),
        _: 1
      }, 8, ["modelValue", "title"])], 64);
    };
  }
};